import { console } from 'react-redux-app/lib/modules/core/utils';
import { handleOnEnterException } from 'react-redux-app/lib/modules/routing/utils';

import { INTERNAL_ERROR_URI } from 'react-redux-app/lib/modules/routing/constants';
import { maybeHandleCriticalError } from 'react-redux-app/lib/modules/api/utils';

import { actionLoadSiteGoogleToolRequest } from '../../actions/loadSiteGoogleTool';
import { getLoadSiteGoogleToolError } from '../../selectors/errors';


export default ({ getState, dispatch }) => (
  function loadSiteGoogleToolHandler(nextState, successCallback, errorCallback) {
    dispatch(
      actionLoadSiteGoogleToolRequest()
    ).then(
      () => {
        if (handleOnEnterException(getState(), errorCallback, INTERNAL_ERROR_URI)) {
          return;
        }

        const error = getLoadSiteGoogleToolError(getState());
        if (
          error
          && maybeHandleCriticalError(nextState.location, error.globalErrors, errorCallback)
        ) {
          return;
        }

        successCallback();
      }
    ).catch(error => {
      console.consoleError('loadSiteGoogleToolHandler failed', error);
      errorCallback(INTERNAL_ERROR_URI);
    });
  }
);
